import { navigate, PageProps } from 'gatsby'
import clsx from 'clsx'
import {
  Avatar,
  Button,
  Card,
  Divider,
  Form,
  Input,
  Label,
  SEO,
  Title,
} from 'components/common'
import Layout from 'components/layouts/tow-column'

const onBack = () => navigate('../')

export const Head = () => <SEO title={'アカウント'} />

const IndexPage = (props: PageProps<Queries.Query>): JSX.Element => {
  return (
    <>
      <Layout title="アカウント" onBack={onBack}>
        <Divider space="medium" />

        <div className={clsx('w-2/6')}>
          <Layout.Section size="large">
            <Layout.Item>
              <Title level={4} style={{ paddingTop: '24px' }}>
                アカウント情報
              </Title>
            </Layout.Item>
          </Layout.Section>
        </div>

        <Layout.Section size="small">
          <Layout.Item>
            <Card shadow>
              <Title level={4}>プロフィール</Title>
              <Form component="form" name="accounts">
                <div className={clsx('flex', 'w-full', 'my-10')}>
                  <Avatar className={clsx('mr-6')}>User</Avatar>
                  <Button type="default" className={clsx('mr-6')}>
                    写真を変更する
                  </Button>
                  <Button type="default" className={clsx('mr-6')}>
                    写真を削除する
                  </Button>
                </div>

                <div className={clsx('flex', 'w-full')}>
                  <Form.Item style={{ width: '48%', marginRight: '4%' }}>
                    <Label>姓</Label>
                    <Input />
                  </Form.Item>
                  <Form.Item style={{ width: '48%' }}>
                    <Label>名</Label>
                    <Input />
                  </Form.Item>
                </div>

                <div className={clsx('flex', 'w-full')}>
                  <Form.Item style={{ width: '48%', marginRight: '4%' }}>
                    <Label>メールアドレス</Label>
                    <Input />
                  </Form.Item>
                  <Form.Item style={{ width: '48%' }}>
                    <Label>電話番号（任意）</Label>
                    <Input />
                  </Form.Item>
                </div>
              </Form>
            </Card>
            <Card>
              <Title level={5}>パスワードを変更する</Title>
              <p>... へログインするためのパスワードを変更する。</p>
              <Button type="default" className={clsx('mt-6')}>
                パスワードを変更する
              </Button>
            </Card>
          </Layout.Item>
        </Layout.Section>
      </Layout>
    </>
  )
}

export default IndexPage
